module.exports = __webpack_public_path__ + "static/img/microBlogs.efaf6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/microBlogs.png
// module id = I4YU
// module chunks = 8